module.exports = __webpack_public_path__ + "img/Participating.187320a8.svg";